import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  "@global": {
    ".MuiDialogContent-root:first-child": {
      paddingTop: 8,
    },
  },
  icon: {
    color: theme.palette.neutral300,
  },
  button: {
    width: "100%",
    maxWidth: "164px",
    height: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },
  dialog: {
    backgroundColor: theme.palette.background200,
    borderRadius: "16px",
    margin: 0,
    position: "absolute",
    top: 0,
    right: 0,
    maxWidth: "400px",
    display: "flex",
    flexDirection: "column",
    height: "100vh", // Full height of the viewport
  },
  header: {
    display: "flex",
    backgroundColor: theme.palette.background100,
    height: "73px",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 3),
  },
  title: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "25px",
    letterSpacing: "-0.25%",
    color: theme.palette.neutral400,
  },
  content: {
    backgroundColor: theme.palette.background200,
    overflow: "hidden",
    padding: 0,
    flex: 1,
  },
  backgroundBotoes: {
    backgroundColor: theme.palette.background100,
  },
  buttonsContainer: {
    backgroundColor: theme.palette.background100,
    height: "72px",
    borderTop: `1px solid ${theme.palette.neutral200}`,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  fieldLabel: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  filterRow: {
    marginBottom: "24px",
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(2),
    marginLeft: "12px",
  },
  checkbox: {
    borderRadius: "50%",
  },
  autocomplete: {
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",
    height: "52px",
    justify: "Space-between",

    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      height: "52px",
    },
  },
  autocompleteLupa: {
    "& .MuiAutocomplete-popupIndicator": { transform: "none" },
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",
    height: "52px",
    justify: "Space-between",

    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      height: "52px",
    },
  },
  searchContactField: {
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",
    height: "52px",
    justifyContent: "space-between",

    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      height: "52px",
      "& fieldset": {
        borderColor: theme.palette.neutral300,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.neutral400,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary200,
      },
    },
    "& .MuiInputBase-input": {
      color: theme.palette.neutral400,
      "&::placeholder": {
        color: theme.palette.neutral400,
        opacity: 1,
      },
    },
  },
  dropdownPaper: {
    marginTop: "8px",
    maxHeight: "400px",
    overflow: "auto",
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",

    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: theme.palette.background200,
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.neutral300,
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.neutral400,
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.neutral300,
      },
    },
    "& .MuiInputBase-input": {
      "&::placeholder": {
        color: theme.palette.neutral400,
        opacity: 1,
      },
    },
  },
}))

export default useStyles
